import { createFileRoute } from '@tanstack/react-router'

import { Footer } from '../components/landing/Footer'
import { Header } from '../components/landing/Header'
import { buildOgMeta } from '../utils/og'

const SectionHeading = ({ number, children }: { number: string; children: React.ReactNode }) => (
    <h2 className="mt-12 text-2xl font-bold text-brand-dark">
        <span className="mr-2 text-primary">{number}.</span>
        {children}
    </h2>
)

function TermsPage() {
    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main>
                <section className="py-24">
                    <div className="mx-auto max-w-[900px] px-6">
                        <div className="mb-6 inline-block rounded-full bg-brand-yellow px-4 py-1 text-[10px] font-bold uppercase tracking-widest text-brand-dark">
                            Jogi információk
                        </div>
                        <h1 className="mb-6 text-4xl font-bold leading-tight text-brand-dark md:text-5xl">
                            Általános Szerződési Feltételek
                        </h1>

                        <article className="mt-12 space-y-4 text-base leading-relaxed text-brand-dark">
                            <SectionHeading number="1">Szolgáltató adatai</SectionHeading>
                            <div className="rounded-2xl border border-slate-200 bg-white p-6 text-sm">
                                <p className="font-semibold">
                                    SOL-Y-MAR Korlátolt Felelősségű Társaság
                                </p>
                                <p>Székhely: 2083 Solymár, Bánya utca 1.</p>
                                <p>Cégjegyzékszám: 13-09-240569</p>
                                <p>Adószám: 29143005-2-13</p>
                                <p>
                                    Weboldal:{' '}
                                    <a
                                        href="https://longyapp.com/"
                                        className="text-primary hover:underline"
                                    >
                                        https://longyapp.com/
                                    </a>
                                </p>
                                <p>
                                    Email:{' '}
                                    <a
                                        href="mailto:info@longyapp.com"
                                        className="text-primary hover:underline"
                                    >
                                        info@longyapp.com
                                    </a>
                                </p>
                                <p>Képviseli: Fábián-Kovács Kinga ügyvezető</p>
                            </div>

                            <SectionHeading number="2">A szolgáltatás tárgya</SectionHeading>
                            <p>
                                A Szolgáltató a weboldalon és a mobilalkalmazásban elérhető
                                egészség- és életmódszolgáltatásokat, valamint az azokhoz kapcsolódó
                                időpontfoglalási és online konzultációs funkciókat biztosítja.
                            </p>

                            <SectionHeading number="3">Megrendelés és fizetés</SectionHeading>
                            <p>
                                A megrendelés a szolgáltatás kiválasztásával és a foglalás
                                visszaigazolásával jön létre, a fizetés a felületen feltüntetett
                                fizetési módok valamelyikén keresztül teljesíthető.
                            </p>

                            <SectionHeading number="4">Elállás</SectionHeading>
                            <p>
                                A Felhasználót a vonatkozó jogszabályok szerinti elállási és
                                lemondási jog illeti meg, amelynek feltételeit és határidejét a
                                szolgáltatás típusa határozza meg.
                            </p>

                            <SectionHeading number="5">Panaszkezelés</SectionHeading>
                            <p>
                                A szolgáltatással kapcsolatos panaszokat a Szolgáltató a fenti
                                elérhetőségeken fogadja, és azokat a jogszabályban előírt határidőn
                                belül kivizsgálja.
                            </p>

                            <SectionHeading number="6">Záró rendelkezések</SectionHeading>
                            <p>
                                A jelen Általános Szerződési Feltételekben nem szabályozott
                                kérdésekben a magyar jog rendelkezései az irányadók, a Szolgáltató
                                pedig fenntartja a feltételek egyoldalú módosításának jogát.
                            </p>

                            <div className="mt-12 border-t border-slate-200 pt-6 text-sm text-brand-gray">
                                <p>SOL-Y-MAR Spirit Kft.</p>
                                <p>Képviseli: Fábián-Kovács Kinga ügyvezető</p>
                                <p>Szolgáltató</p>
                            </div>
                        </article>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export const Route = createFileRoute('/terms')({
    component: TermsPage,
    loader: async ({ context }) => {
        const [, websiteSettings] = await Promise.allSettled([
            context.apiUtils.webContent.getAllPublic.ensureData(),
            context.apiUtils.websiteSettings.getPublic.ensureData(),
        ])
        return {
            websiteSettings: websiteSettings.status === 'fulfilled' ? websiteSettings.value : null,
        }
    },
    head: ({ loaderData }) => ({
        meta: buildOgMeta({
            title: 'Long-Y - Általános Szerződési Feltételek',
            url: `${import.meta.env.VITE_WEB_URL || ''}/terms`,
            websiteSettings: loaderData?.websiteSettings,
        }),
    }),
})
